<template>
  <div class="form-page">
    <!-- calendar -->
    <div class="form-calendar__wrap">
      <div class="form-calendar__item"><span class="form-button">1</span></div>
      <div class="form-calendar__item"><span class="form-button">2</span></div>
      <div class="form-calendar__item"><span class="form-button">3</span></div>
      <div class="form-calendar__item"><span class="form-button">4</span></div>
      <div class="form-calendar__item"><span class="form-button">5</span></div>
      <div class="form-calendar__item"><span class="form-button">6</span></div>
      <div class="form-calendar__item"><span class="form-button">7</span></div>
      <div class="form-calendar__item"><span class="form-button">8</span></div>
      <div class="form-calendar__item"><span class="form-button">9</span></div>
      <div class="form-calendar__item"><span class="form-button">10</span></div>
      <div class="form-calendar__item"><span class="form-button">11</span></div>
      <div class="form-calendar__item"><span class="form-button">12</span></div>
      <div class="form-calendar__item"><span class="form-button">13</span></div>
      <div class="form-calendar__item"><span class="form-button">14</span></div>
      <div class="form-calendar__item"><span class="form-button">15</span></div>
      <div class="form-calendar__item"><span class="form-button">16</span></div>
      <div class="form-calendar__item"><span class="form-button">17</span></div>
      <div class="form-calendar__item"><span class="form-button">18</span></div>
      <div class="form-calendar__item"><span class="form-button">19</span></div>
      <div class="form-calendar__item"><span class="form-button">20</span></div>
      <div class="form-calendar__item"><span class="form-button">21</span></div>
      <div class="form-calendar__item"><span class="form-button">22</span></div>
      <div class="form-calendar__item"><span class="form-button">23</span></div>
      <div class="form-calendar__item"><span class="form-button">24</span></div>
      <div class="form-calendar__item"><span class="form-button">25</span></div>
      <div class="form-calendar__item"><span class="form-button">26</span></div>
      <div class="form-calendar__item"><span class="form-button">27</span></div>
      <div class="form-calendar__item"><span class="form-button">28</span></div>
      <div class="form-calendar__item"><span class="form-button">29</span></div>
      <div class="form-calendar__item"><span class="form-button">30</span></div>
      <div class="form-calendar__item"><span class="form-button">31</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DayPicker',
  props: ['field'],
  data () {
    return {
      msg: 'some text'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/fields/DayPicker.vue